/** @format */
import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	Output
} from '@angular/core';

import { ProductReviewSliderType } from '@product-reviews/data-access';

@Component({
	selector: 'product-reviews-review-slider',
	templateUrl: './review-slider.component.html',
	styleUrl: './review-slider.component.scss',
	standalone: false
})
export class ReviewSliderComponent implements AfterViewInit {
	@Input() selector = `container-${Math.random()}`;
	@Input() activeScroll = true;
	@Output() buttonDirection = new EventEmitter<string>();

	constructor(private ref: ChangeDetectorRef) {}

	// After the view is initialized, attach a scroll event listener
	ngAfterViewInit() {
		this.buttonDirection.emit(ProductReviewSliderType.NONE);
		this.ref.detectChanges();
	}

	// Emit a custom callback event (not implemented in the provided code)
	scrollList(direction: string): void {
		const container = document.querySelector(`#${this.selector}`);
		const scrollAmount = (container.firstChild.childNodes[0] as HTMLElement).scrollWidth;
		if (container) {
			if (direction === ProductReviewSliderType.LEFT) {
				container.scrollLeft -= scrollAmount;
				this.buttonDirection.emit(ProductReviewSliderType.LEFT);
			} else {
				container.scrollLeft += scrollAmount;
				this.buttonDirection.emit(ProductReviewSliderType.RIGHT);
			}
		}
	}
}
